import styled from "styled-components";

export const Container = styled.div`
    display: block;
    width: 100%;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border-radius: 10px;

    thead {
        tr {
            th {
                padding: 15px 10px;
                font-weight: bold;
                text-align: left;
                background-color: #777;
                color: #FFF;

                &:first-child {
                    border-top-left-radius: 10px;
                }

                &:last-child {
                    border-top-right-radius: 10px;
                }
            }
        }
    }

    tbody {
        tr {
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
            td {
                padding: 15px 10px;
                text-align: left;

                p {
                    color: ${props => props.theme.colors.danger};
                    font-weight: bold;
                    font-size: 9px;
                }
            }

            &:nth-of-type(odd) {
                background-color: #dedede;
            }

            &.error {
                td {
                    background: #ffabab;
                }
            }
        }
    }
`;